import React, { useEffect, useState } from "react";
import { MessageCircle, Send } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_URL } from "@/i18n/translations";
import { trackCTA, trackWhatsApp } from "@/lib/analytics";

/**
 * Sticky bottom-right WhatsApp pill on mobile (≤md).
 * Shows after user scrolls past the hero, hides when lead form is in view.
 */
const StickyMobileCTA = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY > 600;
      const lead = document.getElementById("lead");
      let inLead = false;
      if (lead) {
        const r = lead.getBoundingClientRect();
        inLead = r.top < window.innerHeight && r.bottom > 0;
      }
      setVisible(scrolled && !inLead);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToLead = (e) => {
    e.preventDefault();
    const el = document.getElementById("lead");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed bottom-4 inset-x-4 z-40 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-24 opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex items-center gap-2 rounded-full border border-sand-soft bg-[#0A0A0B]/90 backdrop-blur-xl p-1.5 shadow-2xl">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-cta-whatsapp"
          onClick={() => trackWhatsApp("sticky_mobile")}
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-emerald-500/15 border border-emerald-400/30 text-emerald-300 font-medium text-sm transition active:scale-95"
        >
          <MessageCircle size={16} />
          WhatsApp
        </a>
        <a
          href="#lead"
          onClick={(e) => { trackCTA("start_project", "sticky_mobile"); scrollToLead(e); }}
          data-testid="sticky-cta-lead"
          className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-terracotta hover:bg-[#BD5F3F] text-white font-medium text-sm transition active:scale-95"
        >
          <Send size={14} />
          {t.nav.cta}
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
